import { ConsoleSqlOutlined } from "@ant-design/icons";
import { match } from "assert";
import { ProdcutAndVcSource, SMProduct, UnitPriceType, VcType, TechnologyQuotationStatus, } from "../services/serviceProxy";
import { isGranted } from "./abpUtility";

export function priceCalcuByMultiplier(
    // 电机面价
    motorListPrice: number,
    // 可打折vc面价总和
    vcDiscountablePrice: number,
    // 不可以打折vc面价总和
    vcNoDiscountablePrice: number,
    // 按单不打折vc面价总和
    vcNoDiscountableByListPrice: number,
    // 产品组合数量
    numOfProduct: number,
    // 折扣
    multiplier: number,
) {
    // 通过系数计算总价
    // var priceTotal = ((motorListPrice + vcDiscountablePrice) * multiplier + vcNoDiscountablePrice) * numOfProduct + vcNoDiscountableByListPrice;
    // var priceUnit = priceTotal / numOfProduct;

    // 数量为 0 时按 1 计算，避免除零产生 NaN
    const qty = numOfProduct || 1;
    const price = (motorListPrice + vcDiscountablePrice) * multiplier + vcNoDiscountableByListPrice / qty + vcNoDiscountablePrice
    const priceUnit = isGranted("Role.ExportSales") ? price : Math.round(price);

    const priceTotal = priceUnit * qty;
    return {
        // 总价
        priceTotal: priceTotal,
        // 单价
        priceUnit: priceUnit
    }
}

export function priceCalcuByPriceTotal(
    motorListPrice: number,
    vcDiscountablePrice: number,
    vcNoDiscountablePrice: number,
    vcNoDiscountableByListPrice: number,
    numOfProduct: number,
    priceUnit: number,
) {
    // 通过单台总价计算系数
    //var multiplierStr = (((priceTotal - vcNoDiscountableByListPrice) / numOfProduct - vcNoDiscountablePrice) / (motorListPrice + vcDiscountablePrice)).toFixed(3);
    // 数量为 0 时按 1 计算，避免除零产生 NaN
    const qty = numOfProduct || 1;
    var multiplierStr = ((priceUnit - vcNoDiscountableByListPrice / qty - vcNoDiscountablePrice) / (motorListPrice + vcDiscountablePrice)).toFixed(3);

    var multiplierOriginal = ((priceUnit - vcNoDiscountableByListPrice / qty - vcNoDiscountablePrice) / (motorListPrice + vcDiscountablePrice)).toFixed(12);
    var originalMultiplier = Number(multiplierOriginal); // 原始系数（未四舍五入）
    var multiplier = Number(multiplierStr);
    var priceTotal = priceUnit * qty;
    return {
        // 系数
        multiplier: multiplier,
          // 原始系数（未四舍五入）
        originalMultiplier: originalMultiplier,
        // 单价
        priceTotal: priceTotal
      
    }
}

export function priceCalcuFakePriceForOMS(
    motorListPrice: number,
    vcDiscountablePrice: number,
    vcNoDiscountablePrice: number,
    vcNoDiscountableByListPrice: number,
    numOfProduct: number,
    priceTotal: number,
    multiplier: number,
) {
    // 计算出来的可以放到打折价格里面进行计算的”按单不打折“的vc，用来传递给OMS，因为OMS没有按单不打折的逻辑
    // 一下四种计算公式等效
    // priceTotal = ((motorListPrice + vcDiscountablePrice) * multiplier + ___vcNoDiscountablePrice___) * numOfProduct + vcNoDiscountableByListPrice
    // priceTotal = ((motorListPrice + vcDiscountablePrice + ___fakeNoDiscountablePrice___) * multiplier ) * numOfProduct + vcNoDiscountableByListPrice
    // priceTotal = ((motorListPrice + vcDiscountablePrice + __fakeNoDiscountablePrice__ + __fakeNoneDiscountableByListPrice__) * multiplier ) * numOfProduct
    // priceTotal = ((motorListPrice + vcDiscountablePrice + __fakeNoneDiscountableByListPrice__) * multiplier + ___vcNoDiscountablePrice___ ) * numOfProduct

    // 数量为 0 时按 1 计算，避免除零产生 NaN
    const qty = numOfProduct || 1;
    var fakeNoneDiscountable = (priceTotal - vcNoDiscountableByListPrice) / qty / multiplier - (motorListPrice + vcDiscountablePrice);

    var fakeNoneDiscountableByListPrice = (priceTotal / qty / multiplier) - (motorListPrice + vcDiscountablePrice + fakeNoneDiscountable);
    return {
        // 可以按照正常打折来进行计算的按台不打折和不打折的虚拟面价
        fakeNoneDiscountable: fakeNoneDiscountable,
        // 可以按照正常打折来进行计算的按单不打折的虚拟面价
        fakeNoneDiscountableByListPrice: fakeNoneDiscountableByListPrice,
    }
}



export const calculateDiscountableVCPrice = (
    product: SMProduct
) => {
    // 进口电机及零部件直接读取字段数值
    if (product.source == ProdcutAndVcSource.Import) {
        return product.discountUnitPrice;
    }
    if (product.vc?.length > 0) {
        var dqStatus=product.dqProduct?.technologyQuotation?.dqStatus;
        const listPriceMultiplier=Math.round((product.listPriceMultiplier||0)*10000)/10000 ;
        const hasJinCategoryCode=product.jinCategoryCode&&product.jinCategoryCode.trim()!=' ';
        const shouldShowCal=hasJinCategoryCode&&listPriceMultiplier>0&&(dqStatus==TechnologyQuotationStatus.ExamineSuccess||dqStatus==TechnologyQuotationStatus.Completed);
        const unitPrices = product.vc.filter(vc => vc.discountType === UnitPriceType.Discount).map(vc =>(shouldShowCal&&(vc.vcType==VcType.Custom||vc.vcType==VcType.Industry))? Math.round( vc.unitPrice*listPriceMultiplier):vc.unitPrice);
        if (unitPrices?.length > 0) {
            return unitPrices.reduce((total, num) => total + num);
        }

    }
    return 0;
}
export const calculateNoDiscountableVCPrice = (
    product: SMProduct
) => {
    // 进口电机及零部件直接读取字段数值
    if (product.source == ProdcutAndVcSource.Import) {
        return product.noDiscountByPlatformUnitPrice;
    }

    if (product.vc?.length > 0) {
        var dqStatus=product.dqProduct?.technologyQuotation?.dqStatus;
        const listPriceMultiplier=Math.round((product.listPriceMultiplier||0)*10000)/10000 ;
        const hasJinCategoryCode=product.jinCategoryCode&&product.jinCategoryCode.trim()!=' ';
        const shouldShowCal=hasJinCategoryCode&&listPriceMultiplier>0&&(dqStatus==TechnologyQuotationStatus.ExamineSuccess||dqStatus==TechnologyQuotationStatus.Completed);
        // 不打折和按台不打折
        const unitPrices = product.vc.filter(vc => vc.discountType === UnitPriceType.NoDiscountByPlatform).map(vc => (shouldShowCal&&(vc.vcType==VcType.Custom||vc.vcType==VcType.Industry))? Math.round( vc.unitPrice*listPriceMultiplier):vc.unitPrice);
        if (unitPrices?.length > 0) {
            return unitPrices.reduce((total, num) => total + num);
        }
    }
    return 0;
}

export const calculateNoDiscountableByListVCPrice = (
    product: SMProduct
) => {

    // 进口电机及零部件直接读取字段数值
    if (product.source == ProdcutAndVcSource.Import) {
        return product.noDiscountByListUnitPrice;
    }

    if (product.vc?.length > 0) {
        var dqStatus=product.dqProduct?.technologyQuotation?.dqStatus;
        const listPriceMultiplier=Math.round((product.listPriceMultiplier||0)*10000)/10000 ;
        const hasJinCategoryCode=product.jinCategoryCode&&product.jinCategoryCode.trim()!=' ';
        const shouldShowCal=hasJinCategoryCode&&listPriceMultiplier>0&&(dqStatus==TechnologyQuotationStatus.ExamineSuccess||dqStatus==TechnologyQuotationStatus.Completed);
        const unitPrices = product.vc.filter(vc => vc.discountType === UnitPriceType.NoDiscountByList).map(vc => (shouldShowCal&&(vc.vcType==VcType.Custom||vc.vcType==VcType.Industry))? Math.round( vc.unitPrice*listPriceMultiplier):vc.unitPrice);
        if (unitPrices?.length > 0) {
            return unitPrices.reduce((total, num) => total + num);
        }
    }
    return 0;
}

//设置期望折扣
export const setexpectMultiplier = function (record: SMProduct) {
    // 数量为 0 时改为 1，保证计算与后续传值一致
    if (!record.numberOfProduct) {
        record.numberOfProduct = 1;
    }
    const { priceUnit, priceTotal } = priceCalcuByMultiplier(record.unitPrice,
        calculateDiscountableVCPrice(record),
        calculateNoDiscountableVCPrice(record),
        calculateNoDiscountableByListVCPrice(record),
        record.numberOfProduct,
        record.expectMultiplier || record.defaultMultiplier)

    if (record.expectMultiplier === 0 || record.expectMultiplier === null || record.expectMultiplier === undefined) {
        // if there is no expected multiplier
        record.expectMultiplier = record.defaultMultiplier;
    }
    //设置单价
    record.productPrice = priceUnit;
    //设置总价
    record.price = priceTotal;
}
//设置总价
export const setprice = (record: SMProduct) => {
    console.log("价格变更",record.productPrice);
    // 数量为 0 时改为 1，保证计算与后续传值一致
    if (!record.numberOfProduct) {
        record.numberOfProduct = 1;
    }
    const {
        // 系数
        multiplier,
        // 原始系数（未四舍五入）
        originalMultiplier,
        // 总价
        priceTotal
    } = priceCalcuByPriceTotal(
        record.unitPrice,
        calculateDiscountableVCPrice(record),
        calculateNoDiscountableVCPrice(record),
        calculateNoDiscountableByListVCPrice(record),
        record.numberOfProduct,
        record.productPrice
    )
    //设置单价
    //record.productPrice = priceUnit;
    //设置总价
    record.price = priceTotal;
    //设置系数
    record.expectMultiplier = multiplier <= 0 ? 0 : multiplier;

    //设置原始系数（未四舍五入）
    record.originalMultiplier = originalMultiplier <= 0 ? 0 : originalMultiplier;
}